var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.2-My-Profile_About",
    transform: "translate(-285.000000, -1032.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(266.000000, 426.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(19.000000, 528.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,81.2727273 C8.58181818,81.2727273 9.09090909,80.7636364 9.09090909,80.1818182 C9.09090909,79.9636364 9.01818182,79.8181818 8.94545455,79.6 L8,78 L7.05454545,79.6 C6.98181818,79.7454545 6.90909091,79.9636364 6.90909091,80.1818182 C6.90909091,80.7636364 7.41818182,81.2727273 8,81.2727273 Z M12.7272727,83.0909091 L8.72727273,83.0909091 L8.72727273,82 L7.27272727,82 L7.27272727,83.0909091 L3.27272727,83.0909091 C1.45454545,83.0909091 0,84.5454545 0,86.3636364 C0,87.5272727 0.581818182,88.4727273 1.45454545,89.0545455 L1.45454545,94 L14.5454545,94 L14.5454545,89.0545455 C15.4181818,88.4727558 16,87.4545455 16,86.3636364 C16,84.5454545 14.5454545,83.0909091 12.7272727,83.0909091 Z M12.7272727,88.1818182 C12.2181818,88.1818182 11.7818182,87.9636364 11.4181818,87.6727273 L10.3272727,86.5818182 L9.23636364,87.6727273 C8.94545455,87.9636364 8.50909091,88.1818182 8,88.1818182 C7.49090909,88.1818182 7.05454545,87.9636364 6.69090909,87.6727273 L5.6,86.5818182 L4.50909091,87.6727273 C4.21818182,87.9636364 3.78181818,88.1818182 3.27272727,88.1818182 C2.25454545,88.1818182 1.45454545,87.3818182 1.45454545,86.3636364 C1.45454545,85.3454545 2.25454545,84.5454545 3.27272727,84.5454545 L12.7272727,84.5454545 C13.7454545,84.5454545 14.5454545,85.3454545 14.5454545,86.3636364 C14.5454545,87.3818182 13.7454545,88.1818182 12.7272727,88.1818182 Z",
    id: "birthday"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.90012df5de21dbbb7cb9a405fd27aae5.svg";
export { ForwardRef as ReactComponent };